import React from "react";
import { useTranslation } from "react-i18next";

export default function Button({ onClick, className, title, type, status ,...prop}) {
  const { t } = useTranslation("components");
  return (
    <button {...prop} onClick={onClick} type={type} className={className}>
      {parseInt(status) === 0
        ? title
        : parseInt(status) === 1
        ? t("button.success")
        : parseInt(status) === 3
        ? t("button.unsuccess")
        : ""}
    </button>
  );
}
